import React from 'react';
import { observer } from 'mobx-react';
import { Modal } from 'semantic-ui-react';
import Materials from './Materials';
import MaterialList from './MaterialList';

export default observer(({ isOpen, onClose, onSelectItem }) => {
  return (
    <Modal size='small' open={isOpen} 
      closeIcon onClose={onClose}
      closeOnDimmerClick={false}>
      <Modal.Header>Select Material</Modal.Header>
      <Modal.Content style={{ height: '380px' }}>
        <Materials
          fixedHeight={300} 
          onClickItem={onSelectItem} 
          ListComponent={MaterialList}
        />
      </Modal.Content>
    </Modal>
  )
})


// WEBPACK FOOTER //
// ./src/components/materials/MaterialSelector.js